import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { AlertTriangle, ChevronDown, Snowflake } from "lucide-react";
import api from "@/lib/api";

export function LossStreakAlerts({ onView }) {
  const [alerts, setAlerts] = useState([]);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const f = () => api.get("/admin/loss-alerts", { params: { threshold: 5 } }).then(({ data }) => setAlerts(data.alerts)).catch(() => {});
    f();
    const i = setInterval(f, 30000);
    return () => clearInterval(i);
  }, []);

  if (!alerts.length) return null;
  return (
    <motion.div initial={{ opacity: 0, y: -10 }} animate={{ opacity: 1, y: 0 }} data-testid="loss-streak-alerts"
      className="mb-6 rounded-2xl border border-pazer-red/50 bg-pazer-red/10">
      <button onClick={() => setOpen((o) => !o)} data-testid="loss-alerts-toggle" className="w-full flex items-center gap-3 px-5 py-3.5 text-left">
        <span className="relative flex h-9 w-9 items-center justify-center rounded-xl bg-pazer-red/20">
          <AlertTriangle className="h-5 w-5 text-pazer-red" />
          <span className="absolute -top-1 -right-1 h-3 w-3 rounded-full bg-pazer-red animate-ping" />
        </span>
        <span className="flex-1">
          <span className="block font-bold" data-testid="loss-alerts-count">{alerts.length} player{alerts.length > 1 ? "s" : ""} on a 5+ loss streak</span>
          <span className="block text-xs text-white/50">Consider a bonus or check in before they leave.</span>
        </span>
        <ChevronDown className={`h-5 w-5 text-white/50 transition-transform ${open ? "rotate-180" : ""}`} />
      </button>
      <AnimatePresence>
        {open && (
          <motion.div initial={{ height: 0, opacity: 0 }} animate={{ height: "auto", opacity: 1 }} exit={{ height: 0, opacity: 0 }} className="overflow-hidden">
            <div className="px-5 pb-4 grid sm:grid-cols-2 lg:grid-cols-3 gap-2">
              {alerts.map((p) => (
                <button key={p.user_id} onClick={() => onView(p.user_id)} data-testid={`loss-alert-${p.user_id}`}
                  className="flex items-center gap-3 rounded-xl bg-pazer-deep/40 hover:bg-pazer-deep/60 px-3 py-2.5 text-left transition-colors">
                  <Snowflake className="h-4 w-4 text-sky-400 shrink-0" />
                  <span className="flex-1 min-w-0">
                    <span className="block font-semibold text-sm truncate">{p.username} <span className="text-white/40 font-normal">{p.mobile}</span></span>
                    <span className="block text-xs text-white/50">Net {Math.round(p.net).toLocaleString()} · balance {Math.round(p.balance).toLocaleString()}</span>
                  </span>
                  <span className="font-mono-pz font-bold text-pazer-red text-sm">{Math.abs(p.current_streak)}L</span>
                </button>
              ))}
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </motion.div>
  );
}
